module.exports = __webpack_public_path__ + "img/case.186e7e4.svg";